import React, { Component } from 'react';
import {
	Col,
	Card,
	CardBody,
	TabContent,
	TabPane,
	NavItem,
	NavLink,
	Label,
	Input,
	Alert,
	Button,
	FormGroup,
	Container,
	CustomInput,
} from 'reactstrap';

import S3 from 'react-aws-s3';

import { Link } from 'react-router-dom';

import { AvForm, AvField, AvInput } from 'availity-reactstrap-validation';

import TestimonyList from '../TestimonyList/TestimonyList';

import classnames from 'classnames';
import AvGroup from 'availity-reactstrap-validation/lib/AvGroup';
import { testimonyUrl } from '../../helpers/url';

export default class Testimony extends Component {
	constructor(props) {
		super(props);
		this.state = {
			breadcrumbItems: [
				{ title: 'Forms', link: '#' },
				{ title: 'Form Wizard', link: '#' },
			],
			activeTab: 1,
			activeTabProgress: 1,
			success: false,
			successMsg: '',
			error: false,
			errorMsg: '',
			fileSubmitError: false,
			fileSubmitErrorMsg: '',

			firstname: '',
			middleName: '',
			lastname: '',
			age: 0,
			gender: '',
			placeOfBirth: '',
			idNumber: '',
			passportNumber: '',
			educationLevel: '',
			jobTitle: '',
			marriage: '',
			economySituation: '',
			familyInfo: '',

			currentSituation: '',
			placeOfImprisonment: '',
			reasonForDetainment: '',
			released: '',
			healthSituation: '',
			chineseLanguageLevel: '',
			havePassport: '',
			religiousLevel: '',
			memberOfCCP: '',

			selfConnection: '',
			selfFirstname: '',
			selfLastname: '',
			selfEmail: '',
			selfPhoneNumber: '',
			selfCountry: '',

			testimonyVideo: false,
			testimonyVoice: false,
			agreement: false,
			allowedToSave: false,

			imageOfPerson: {
				file: null,
				filename: null,
				url: '',
			},
			additionalDocument: {
				file: null,
				filename: null,
				url: '',
			},
		};
		this.toggleTab.bind(this);
		this.stateHandling.bind(this);
	}

	toggleTab(tab) {
		if (this.state.activeTab !== tab) {
			if (tab >= 1 && tab <= 3) {
				this.setState({
					activeTab: tab,
				});
			}
		}
	}

	stateHandling = event => {
		this.setState({
			[event.target.id]: event.target.value,
		});
	};

	radioBtnChange = event => {
		this.setState({
			[event.target.name]: event.target.value,
		});
	};

	fileHandling = event => {
		this.setState({
			[event.target.id]: {
				file: event.target.files[0],
				filename: event.target.files[0].name,
			},
		});
	};

	fileSubmitToS3 = async (file, fileName, fileNumber) => {
		const config = {
			bucketName: process.env.REACT_APP_BUCKET_NAME,
			region: process.env.REACT_APP_REGION,
			accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
			secretAccessKey: process.env.REACT_APP_SECRET_KEY_ID,
		};
		const ReactS3Client = new S3(config);
		await ReactS3Client.uploadFile(file, 'testimonyForm/' + fileName)
			.then(data => {
				if (fileNumber === 'file1') {
					this.setState({
						imageOfPerson: {
							url: data.location,
						},
					});
				} else if (fileNumber === 'file2') {
					this.setState({
						additionalDocument: {
							url: data.location,
						},
					});
				}
			})
			.catch(err => {
				this.setState({
					error: true,
					errorMsg: err.message,
				});
			});
	};

	postToBackend = () => {
		const jwt = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = jwt.jwtToken;

		fetch(testimonyUrl, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', "Authorization": accessToken },
			body: JSON.stringify({
				firstname: this.state.firstname,
				middleName: this.state.middleName,
				lastname: this.state.lastname,
				age: this.state.age,
				gender: this.state.gender,
				placeOfBirth: this.state.placeOfBirth,
				idNumber: this.state.idNumber,
				passportNumber: this.state.passportNumber,
				educationLevel: this.state.educationLevel,
				jobTitle: this.state.jobTitle,
				marriage: this.state.marriage,
				economySituation: this.state.economySituation,
				familyInfo: this.state.familyInfo,

				currentSituation: this.state.currentSituation,
				placeOfImprisonment: this.state.placeOfImprisonment,
				reasonForDetainment: this.state.reasonForDetainment,
				released: this.state.released,
				healthSituation: this.state.healthSituation,
				chineseLanguageLevel: this.state.chineseLanguageLevel,
				havePassport: this.state.havePassport,
				religiousLevel: this.state.religiousLevel,
				memberOfCCP: this.state.memberOfCCP,

				selfConnection: this.state.selfConnection,
				selfFirstname: this.state.selfFirstname,
				selfLastname: this.state.selfLastname,
				selfEmail: this.state.selfEmail,
				selfPhoneNumber: this.state.selfPhoneNumber,
				selfCountry: this.state.selfCountry,

				testimonyVideo: this.state.testimonyVideo ? 'Yes' : 'No',
				testimonyVoice: this.state.testimonyVoice ? 'Yes' : 'No',
				agreement: this.state.agreement ? 'Yes' : 'No',
				allowedToSave: this.state.allowedToSave ? 'Yes' : 'No',

				imageOfPersonFile: this.state.imageOfPerson.file,
				imageOfPersonS3Location: this.state.imageOfPerson.url,
				additionalFile: this.state.additionalDocument.file,
				additionalFileS3Location: this.state.additionalDocument.url,
			}),
		})
			.then(res => res.json())
			.then(data => {
				if (data.message) {
					this.setState({
						success: true,
						successMsg: data.message,
					});
					this.props.history.push('/testimonyList');
				} else if (data.error) {
					this.setState({
						fileSubmitError: true,
						fileSubmitErrorMsg: data.error,
					});
				}
			})
			.catch(err => {
				this.setState({
					error: true,
					errorMsg: err,
				});
			});
	};

	finalSubmit = async () => {
		if (this.state.imageOfPerson.file !== null) {
			await this.fileSubmitToS3(this.state.imageOfPerson.file, this.state.imageOfPerson.filename, 'file1');
		}
		if (this.state.additionalDocument.file !== null) {
			await this.fileSubmitToS3(this.state.additionalDocument.file, this.state.additionalDocument.filename, 'file2');
		}

		await this.postToBackend();
	};

	responseHandling = event => {
		this.setState({
			[event.target.id]: false,
			[event.target.id + 'Msg']: '',
		});
	};

	render() {
		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid={true}>
						<Col lg="12">
							<Card>
								<CardBody>
									<h4 className="card-title mb-4">Testimony Registration Form</h4>

									<div id="basic-pills-wizard" className="twitter-bs-wizard">
										<ul className="twitter-bs-wizard-nav nav nav-pills nav-justified">
											<NavItem>
												<NavLink className={classnames({ active: this.state.activeTab === 1 })}>
													<span className="step-number">1</span>
													<span className="step-title">Guwahliq</span>
												</NavLink>
											</NavItem>
											<NavItem>
												<NavLink className={classnames({ active: this.state.activeTab === 2 })}>
													<span className="step-number">2</span>
													<span className="step-title">Tutulushqa munasiwetlik tepsilati</span>
												</NavLink>
											</NavItem>
											<NavItem>
												<NavLink className={classnames({ active: this.state.activeTab === 3 })}>
													<span className="step-number">3</span>
													<span className="step-title">Guwahliq bergüchi toghrisida, ayaqlashturush</span>
												</NavLink>
											</NavItem>
										</ul>

										<TabContent activeTab={this.state.activeTab} className="twitter-bs-wizard-tab-content">
											<TabPane tabId={1}>
												<AvForm
													className="form-horizontal"
													onValidSubmit={() => {
														this.toggleTab(this.state.activeTab + 1);
													}}>
													<FormGroup row>
														<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
															Surname
														</Label>
														<Col md={5}>
															<AvField
																name="firstname"
																className="form-control"
																type="text"
																placeholder="Isim"
																id="firstname"
																errorMessage="Enter Persons First Name"
																validate={{ required: { value: true } }}
																onChange={this.stateHandling}
																value={this.state.firstname}
															/>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
															Middle Name
														</Label>
														<Col md={5}>
															<Input
																className="form-control"
																type="text"
																placeholder="Leqimi / Texellusi"
																id="middleName"
																onChange={this.stateHandling}
																value={this.state.middleName}
															/>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
															Lastname
														</Label>
														<Col md={5}>
															<AvField
																name="lastname"
																className="form-control"
																type="text"
																placeholder="Familisi"
																id="lastname"
																errorMessage="Enter Persons Last Name"
																validate={{ required: { value: true } }}
																onChange={this.stateHandling}
																value={this.state.lastname}
															/>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label htmlFor="example-number-input" className="col-md-2 col-form-label">
															Age
														</Label>
														<Col md={5}>
															<Input
																className="form-control"
																type="number"
																placeholder="yishi"
																id="age"
																onChange={this.stateHandling}
																value={this.state.age}
															/>
														</Col>
													</FormGroup>
													<FormGroup row onChange={this.radioBtnChange}>
														<Label className="col-md-2 col-form-label">Gender</Label>
														<Col md={2}>
															<div className="custom-control custom-radio mb-3">
																<Input type="radio" id="genderMale" value="Male" name="gender" className="custom-control-input" />
																<Label className="custom-control-label" htmlFor="genderMale">
																	Male
																</Label>
															</div>
														</Col>
														<div className="custom-control custom-radio mb-3">
															<Input type="radio" id="genderFemale" value="Female" name="gender" className="custom-control-input" />
															<Label className="custom-control-label" htmlFor="genderFemale">
																Female
															</Label>
														</div>
													</FormGroup>
													<FormGroup row>
														<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
															Place of Birth
														</Label>
														<Col md={5}>
															<Input
																className="form-control"
																type="text"
																placeholder="Tugulgan Yurti"
																id="placeOfBirth"
																onChange={this.stateHandling}
																value={this.state.placeOfBirth}
															/>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
															Chinese ID number
														</Label>
														<Col md={5}>
															<Input
																className="form-control"
																type="text"
																placeholder="Ziyenkeshlikke uchurghuchining xitay kimlik numuri"
																id="idNumber"
																onChange={this.stateHandling}
																value={this.state.idNumber}
															/>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
															Passport Number
														</Label>
														<Col md={5}>
															<Input
																className="form-control"
																type="text"
																placeholder="Ziyenkeshlikke uchurghuchining passport numuri"
																id="passportNumber"
																onChange={this.stateHandling}
																value={this.state.passportNumber}
															/>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
															Image of the person
														</Label>
														<Col md={5}>
															<div className="custom-file mb-2">
																<CustomInput type="file" className="custom-file-input" id="imageOfPerson" onChange={this.fileHandling} />
																<Label className="custom-file-label" htmlFor="imageOfPerson">
																	Choose file
																</Label>
															</div>
														</Col>
														{this.state.imageOfPerson.filename !== null ? (
															<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																{this.state.imageOfPerson.filename}
															</Label>
														) : (
															''
														)}
													</FormGroup>
													<h4 className="card-title">Extra</h4>
													<FormGroup row className="mb-0">
														<Label className="col-md-2 col-form-label">Education level / Medeniyet sewiyesi</Label>
														<Col md={10}>
															<select
																className="custom-select"
																id="educationLevel"
																onChange={this.stateHandling}
																value={this.state.educationLevel}>
																<option defaultValue>Namelum</option>
																<option value="Sawatsiz">Sawatsiz</option>
																<option value="Bashlanguch">Bashlanguch</option>
																<option value="toluqsiz">toluqsiz</option>
																<option value="toluq">toluq ottura</option>
																<option value="bakalawor">bakalawor</option>
																<option value="magistir">magistir</option>
																<option value="doktur">doktur</option>
																<option value="pirofissor">pirofissor</option>
															</select>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
															Job title / kespi
														</Label>
														<Col md={5}>
															<Input
																className="form-control"
																type="text"
																placeholder="Muallem"
																id="jobTitle"
																onChange={this.stateHandling}
																value={this.state.jobTitle}
															/>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label className="col-md-2 col-form-label">Marriage</Label>
														<Col md={10}>
															<select className="custom-select" id="marriage" onChange={this.stateHandling} value={this.state.marriage}>
																<option defaultValue>Namelum</option>
																<option value="boytaq">boytaq</option>
																<option value="toy">toy qilghan</option>
																<option value="ajirashqan">ajirashqan</option>
																<option value="yalghuz ana / yalghuz ata">yalghuz ana / yalghuz ata</option>
															</select>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
															Economy situation
														</Label>
														<Col md={5}>
															<Input
																className="form-control"
																type="text"
																placeholder="Aile yaki jemet iqtisadidiki orni"
																id="economySituation"
																onChange={this.stateHandling}
																value={this.state.economySituation}
															/>
														</Col>
														<p className="card-title-desc">
															aile yaki jemetidiki kishiler mushu kishining iqtisadigha tayinamdu? yekke tijaretchimu yakikarixanchimu?
														</p>
													</FormGroup>
													<FormGroup row>
														<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
															Info about any additional family members
														</Label>
														<Col md={5}>
															<Input
																type="textarea"
																id="familyInfo"
																maxLength="1000"
																rows="10"
																placeholder="A’ile ezalirini bilsingiz yézip béring, ularning aqiwiti qandaq."
																onChange={this.stateHandling}
																value={this.state.familyInfo}
															/>
														</Col>
														<p className="card-title-desc">(isim, familisi, yéshi, hazirqi ehwali)</p>
													</FormGroup>

													<ul className="pager wizard twitter-bs-wizard-pager-link">
														<li className="next">
															<Button to="#" type="submit">
																Next
															</Button>
														</li>
													</ul>
												</AvForm>
											</TabPane>

											<TabPane tabId={2}>
												<AvForm
													className="form-horizontal"
													onValidSubmit={() => {
														this.toggleTab(this.state.activeTab + 1);
													}}>
													<FormGroup row>
														<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
															Any additional documents / Munasiwetlik höjjetler
														</Label>
														<Col md={5}>
															<div className="custom-file mb-2">
																<CustomInput
																	type="file"
																	className="custom-file-input"
																	id="additionalDocument"
																	onChange={this.fileHandling}
																/>
																<Label className="custom-file-label" htmlFor="additionalDocument">
																	Choose file
																</Label>
															</div>
														</Col>
														{this.state.additionalDocument.filename !== null ? (
															<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																{this.state.additionalDocument.filename}
															</Label>
														) : (
															''
														)}
													</FormGroup>
													<FormGroup row>
														<Label className="col-md-2 col-form-label">Current situation / Hazerki ehwali</Label>
														<Col md={10}>
															<select
																className="custom-select"
																id="currentSituation"
																onChange={this.stateHandling}
																value={this.state.currentSituation}>
																<option defaultValue>Namelum</option>
																<option value="tutulghan">tutulghan</option>
																<option value="yoqap ketken">yoqap ketken</option>
																<option value="ölgen">ölgen</option>
																<option value="türmide">türmide</option>
																<option value="jaza lagirda">jaza lagirda</option>
															</select>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
															Place of imprisonment
														</Label>
														<Col md={5}>
															<Input
																className="form-control"
																type="text"
																placeholder="Qamalghan orni"
																id="placeOfImprisonment"
																onChange={this.stateHandling}
																value={this.state.placeOfImprisonment}
															/>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
															Reason for their detainment/imprisonment/death
														</Label>
														<Col md={5}>
															<Input
																type="textarea"
																id="reasonForDetainment"
																onChange={this.stateHandling}
																value={this.state.reasonForDetainment}
																maxLength="1000"
																rows="10"
																placeholder="Tutulush, yoqap kitish, ülüsh sewebi"
															/>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label className="col-md-2 col-form-label">Original health situation / Esli salametlik ehwali</Label>
														<Col md={10}>
															<select
																className="custom-select"
																id="healthSituation"
																onChange={this.stateHandling}
																value={this.state.healthSituation}>
																<option defaultValue>Namelum</option>
																<option value="saghlam">saghlam</option>
																<option value="késeljan">késeljan</option>
																<option value="nachar">nachar</option>
																<option value="miyip">miyip</option>
																<option value="bashqa">bashqa</option>
															</select>
														</Col>
													</FormGroup>
													<AvGroup row onChange={this.radioBtnChange} validate={{ required: { value: true } }}>
														<Label htmlFor="example-number-input" className="col-md-2 col-form-label">
															Is he/she released / Qoyup bérilgenmu ?
														</Label>

														<Col md={2}>
															<div className="custom-control custom-radio mb-3">
																<AvInput type="radio" id="releasedYes" value="Yes" name="released" className="custom-control-input" />
																<Label className="custom-control-label" htmlFor="releasedYes">
																	Yes
																</Label>
															</div>
														</Col>
														<div className="custom-control custom-radio mb-3">
															<AvInput type="radio" id="releasedNo" value="No" name="released" className="custom-control-input" />
															<Label className="custom-control-label" htmlFor="releasedNo">
																No
															</Label>
														</div>
													</AvGroup>
													<FormGroup row>
														<Label className="col-md-2 col-form-label">Chinese language level / Xitayche til sewiyesi</Label>
														<Col md={10}>
															<select
																className="custom-select"
																id="chineseLanguageLevel"
																onChange={this.stateHandling}
																value={this.state.chineseLanguageLevel}>
																<option defaultValue>Namelum</option>
																<option value="yoq">yoq</option>
																<option value="az tola bilidu">az tola bilidu</option>
																<option value="ep qilalaydu">gep qilalaydu</option>
																<option value="yizip oqalalaydu">yizip oqalalaydu</option>
																<option value="mükemmmel">mükemmmel</option>
															</select>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label className="col-md-2 col-form-label">Does he/she have passport / Pasporti barmu ?</Label>
														<Col md={10}>
															<select
																className="custom-select"
																id="havePassport"
																onChange={this.stateHandling}
																value={this.state.havePassport}>
																<option defaultValue>Namelum</option>
																<option value="Yes">Yes</option>
																<option value="No">No</option>
															</select>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label className="col-md-2 col-form-label">Religious level / Diniy sewiyesi</Label>
														<Col md={10}>
															<select
																className="custom-select"
																id="religiousLevel"
																onChange={this.stateHandling}
																value={this.state.religiousLevel}>
																<option defaultValue>Namelum</option>
																<option value="diniy terbiye körmigen">diniy terbiye körmigen</option>
																<option value="otturahal">otturahal</option>
																<option value="yuquri diniy sewiyege ige">yuquri diniy sewiyege ige</option>
															</select>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label className="col-md-2 col-form-label">
															Member of Chinese Communist Party / Xitay komunist partiye ezasi mu ?
														</Label>
														<Col md={10}>
															<select
																className="custom-select"
																id="memberOfCCP"
																onChange={this.stateHandling}
																value={this.state.memberOfCCP}>
																<option defaultValue>Namelum</option>
																<option value="Yes">Yes</option>
																<option value="No">No</option>
															</select>
														</Col>
													</FormGroup>

													<ul className="pager wizard twitter-bs-wizard-pager-link">
														<li className="previous">
															<Button
																to="#"
																onClick={() => {
																	this.toggleTab(this.state.activeTab - 1);
																}}>
																Previous
															</Button>
														</li>
														<li className="next">
															<Button to="#" type="submit">
																Next
															</Button>
														</li>
													</ul>
												</AvForm>
											</TabPane>

											<TabPane tabId={3}>
												<AvForm
													className="form-horizontal"
													onValidSubmit={() => {
														if (window.confirm('Submit and Go Back To Pending Testimony Page?')) this.finalSubmit();
													}}>
													<FormGroup row>
														<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
															Your connection to the person
														</Label>
														<Col md={10}>
															<AvField
																name="yourConnection"
																className="form-control"
																validate={{ required: { value: true } }}
																type="text"
																placeholder="Guwahliq bergüchining ziyenkeshlikke uchurghuchi bilen munasiwiti"
																id="selfConnection"
																onChange={this.stateHandling}
																value={this.state.selfConnection}
															/>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
															Your firstname
														</Label>
														<Col md={5}>
															<AvField
																name="yourFirstname"
																className="form-control"
																validate={{ required: { value: true } }}
																type="text"
																placeholder="Guwahliq bergüchining ismi"
																id="selfFirstname"
																onChange={this.stateHandling}
																value={this.state.selfFirstname}
															/>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
															Your lastname
														</Label>
														<Col md={5}>
															<AvField
																name="yourLastname"
																className="form-control"
																validate={{ required: { value: true } }}
																type="text"
																placeholder="Guwahliq bergüchining familisi"
																id="selfLastname"
																onChange={this.stateHandling}
																value={this.state.selfLastname}
															/>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label for="example-text-input" className="col-md-2 col-form-label">
															Your Email
														</Label>
														<Col md={5}>
															<AvField
																name="yourEmail"
																type="email"
																validate={{ required: { value: true } }}
																className="form-control"
																id="selfEmail"
																placeholder="Èl-xet"
																onChange={this.stateHandling}
																value={this.state.selfEmail}
															/>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label for="example-text-input" className="col-md-2 col-form-label">
															Your phone number
														</Label>
														<Col md={5}>
															<Input
																type="text"
																className="form-control"
																id="selfPhoneNumber"
																placeholder="Tilfun numur"
																onChange={this.stateHandling}
																value={this.state.selfPhoneNumber}
															/>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label for="example-text-input" className="col-md-2 col-form-label">
															Country you live in
														</Label>
														<Col md={5}>
															<Input
																type="text"
																className="form-control"
																id="selfCountry"
																placeholder="Guwahliq bergüchining turushluq döleti"
																onChange={this.stateHandling}
																value={this.state.selfCountry}
															/>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label className="col-md-2 col-form-label">Bashqa türdiki guwahliqni bérishni xalamsiz?</Label>
														<Col md={2}>
															<div className="custom-control custom-checkbox mb-3">
																<Input type="checkbox" className="custom-control-input" id="testimonyVideo" />
																<Label
																	className="custom-control-label"
																	htmlFor="testimonyVideo"
																	onClick={e => {
																		this.setState({ testimonyVideo: !this.state.testimonyVideo });
																	}}>
																	Video guwahni bérishni xalaymen
																</Label>
															</div>
														</Col>
														<div className="custom-control custom-checkbox mb-3">
															<Input type="checkbox" className="custom-control-input" id="testimonyVoice" />
															<Label
																className="custom-control-label"
																htmlFor="testimonyVoice"
																onClick={e => {
																	this.setState({ testimonyVoice: !this.state.testimonyVoice });
																}}>
																Awazlik guwahni bérishni xalaymen
															</Label>
														</div>
													</FormGroup>
													<FormGroup row>
														<Label className="col-md-2 col-form-label">GDPR</Label>
														<Col md={2}>
															<div className="custom-control custom-checkbox mb-3">
																<AvInput
																	name="agreement"
																	validate={{ required: { value: true } }}
																	type="checkbox"
																	className="custom-control-input"
																	id="agreement"
																/>
																<Label
																	className="custom-control-label"
																	htmlFor="agreement"
																	onClick={e => {
																		this.setState({ agreement: !this.state.agreement });
																	}}>
																	I consent to having this website store my submitted information so they can respond to my inquiry.
																</Label>
															</div>
														</Col>
													</FormGroup>
													<FormGroup row>
														<Label className="col-md-2 col-form-label">
															Melumatliriningiz bu torbettin üchürülgiche bir mezgil saqlinidu. Egerde teminlingen uchurliringizni torda
															saqlashni xalimisingiz biz bilen alaqilishing, biz derhal yötkep saqlaymiz
														</Label>
														<Col md={2}>
															<div className="custom-control custom-checkbox mb-3">
																<AvInput
																	name="allowedToSave"
																	validate={{ required: { value: true } }}
																	type="checkbox"
																	className="custom-control-input"
																	id="allowedToSave"
																/>
																<Label
																	className="custom-control-label"
																	htmlFor="allowedToSave"
																	onClick={e => {
																		this.setState({ allowedToSave: !this.state.allowedToSave });
																	}}>
																	maqul, saxlansa bolidu
																</Label>
															</div>
														</Col>
													</FormGroup>
													<ul className="pager wizard twitter-bs-wizard-pager-link">
														<li className="previous">
															<Button
																to="#"
																onClick={() => {
																	this.toggleTab(this.state.activeTab - 1);
																}}>
																Previous
															</Button>
														</li>
														<li className="next">
															<Button to="#" type="submit">
																Send
															</Button>
														</li>
													</ul>
												</AvForm>
											</TabPane>

											<div className="mt-5 text-center">
												<Alert id="success" color="success" isOpen={this.state.success} toggle={this.responseHandling}>
													{this.state.successMsg}
												</Alert>
											</div>
											<div className="mt-5 text-center">
												<Alert id="error" color="error" isOpen={this.state.error} toggle={this.responseHandling}>
													{this.state.errorMsg}
												</Alert>
											</div>
											<div className="mt-5 text-center">
												<Alert
													id="error"
													color="error"
													isOpen={this.state.fileSubmitError}
													toggle={e => {
														this.setState({ fileSubmitError: !this.state.fileSubmitError });
													}}>
													{this.state.fileSubmitErrorMsg}
												</Alert>
											</div>
										</TabContent>
									</div>
								</CardBody>
							</Card>
						</Col>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}
